import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { FeatureFlag } from 'app/api/services/site-configs/types';

import { Badge, BadgeState } from 'app/design-system/components/Badge';
import { formatPhoneNumber } from 'app/design-system/components/PhoneInput/phone-input-helpers';
import { Widget } from 'app/design-system/components/Widget/Widget';
import { ICON_NAME_CHECK_FILLED } from 'app/design-system/constants/IconNames';
import { useTranslation } from 'app/lang';
import { accountFullName, selectCashback, selectClientProfilePhone } from 'app/lib/account/selectors';
import { useFeatureFlag } from 'app/lib/feature-flags';
import { CashbackLevel } from 'app/widgets/CashbackLevel';

import { UserName } from './components/UserName';

import dictionary from './AccountInformation.dictionary.json';

import styles from './AccountInformation.module.scss';

export const AccountInformation: FC = () => {
  const { t } = useTranslation();
  const isCashbackFeature = useFeatureFlag(FeatureFlag.CASHBACK);

  const userFullName = useSelector(accountFullName);
  const userPhone = useSelector(selectClientProfilePhone);
  const cashback = useSelector(selectCashback);

  return (
    <Widget title={t(dictionary.title)}
            contentClassName={styles.root}>
      <div className={styles.profile}>
        <UserName value={userFullName} />
        {userPhone && (
          <span className={styles.userPhone}>
            {formatPhoneNumber(userPhone)}
          </span>
        )}
      </div>
      <div className={styles.cashback}>
        {isCashbackFeature && cashback && (
          <CashbackLevel levelId={cashback.levelId} />
        )}
        {!isCashbackFeature && cashback && cashback.percentRate && (
          <Badge state={BadgeState.BRAND}
                 icon={ICON_NAME_CHECK_FILLED}>
            {t(dictionary.defaultCashback, { rate: cashback.percentRate })}
          </Badge>
        )}
      </div>
    </Widget>
  );
};
